import { Uploader } from '@syncfusion/ej2-inputs';

import { Grid, Filter, Page, Sort, RecordClickEventArgs } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { closest } from '@syncfusion/ej2-base';

export class CompanyIndexManager {

    constructor(private containerElement: JQuery) { }

    private companiesGrid : Grid;
    

    public initialize() {
        var self = this;

        Grid.Inject(Filter, Page, Sort);

        self.initializeCompaniesTable();
    }

    private initializeCompaniesTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var companiesGridContainer = self.containerElement.find('#companies-grid-container');
        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#Grid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;

        let data: DataManager = new DataManager({
            url: '/api/company/list',
            adaptor: new WebApiAdaptor
        });

        self.companiesGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                columns: [
                    { field: 'Name', headerText: 'Name', autoFit: true, width: 250 },
                    { field: 'Owner', headerText: 'Owner', width: 250,},
                    { field: 'LicenseExpirationDate', headerText: 'Licensed until', width: 150,},
                ],
                allowSorting: true,
                allowPaging: true,
                allowFiltering: false,
                allowSelection: false,
                pageSettings: { pageSize: 100 },
                created: () => {
                    loadingContainer.addClass('d-none');
                    companiesGridContainer.removeClass('d-none');
                    gridContentElement = gridContentElement.find('.e-content')
                },
                recordClick: (args: RecordClickEventArgs) => {
                    if (args.target != undefined && args.rowData != undefined) {
                        var parsedTarget = $(args.target); 
                        var companyId = args.rowData["Id"];
    
                        location.href = `/Company/${companyId}/Detail`;
                    }
                }
            });
            
        self.companiesGrid.appendTo('#Grid');
    }

}